import { AufgabeMessages, AufgabenTyp, aufgabenTypenForRegister } from '@schir-int-client/aufgabe-shared';
import { VerfuegungResource, VerfuegungTyp } from '@schir-int-client/verfuegung-shared';
import { CreateAufgabeDialogData } from './create-aufgabe-dialog.model';
import { CreateAufgabeFormService } from './create-aufgabe.formservice';
import { addAriaAttributesToMatSelect, BaseEditorComponent } from '@schir-int-client/tech';
import { VorlageFacade, VorlageResource } from '@schir-int-client/vorlage-shared';
import { Component, inject, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ApiRootFacade } from '@schir-int-client/api-root';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VerfahrenFacade } from '@schir-int-client/verfahren-shared';
import { RegisterName } from '@schir-int-client/register-shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Component({
	selector: 'schir-int-client-create-aufgabe-dialog',
	templateUrl: './create-aufgabe-dialog.component.html',
	styleUrls: ['./create-aufgabe-dialog.component.scss'],
	providers: [CreateAufgabeFormService],
	standalone: false,
})
export class CreateAufgabeDialogComponent extends BaseEditorComponent implements OnInit {
	private formService = inject(CreateAufgabeFormService);
	private apiRootFacade = inject(ApiRootFacade);
	private verfahrenFacade = inject(VerfahrenFacade);
	private vorlageFacade = inject(VorlageFacade);
	private data = inject<CreateAufgabeDialogData>(MAT_DIALOG_DATA);

	protected readonly verfuegung: VerfuegungResource = this.data.verfuegung;
	protected readonly editMode: boolean = this.data.editMode;
	protected readonly excludeEingetragenerEigentuemer: boolean = this.data.excludeEingetragenerEigentuemer;
	protected readonly isLFPR: boolean = this.apiRootFacade.isLFPR;
	protected readonly vorlagen: Observable<VorlageResource[]> = this.vorlageFacade.getVorlagen();
	protected register: RegisterName;

	readonly aufgabenTypen = AufgabenTyp;
	readonly messages = AufgabeMessages;

	constructor() {
		super();
		this.formService.form.controls.typ.setValidators([Validators.required]);
		if (this.editMode) {
			this.formService.subscribeToAufgabe();
		}
		this.verfahrenFacade.verfahrenSingle.pipe(takeUntilDestroyed()).subscribe(v => {
			this.register = v?.register;
		});
	}

	ngOnInit(): void {
		addAriaAttributesToMatSelect();
	}

	get form() {
		return this.formService.form;
	}

	async submit(): Promise<boolean> {
		return this.formService.submit();
	}

	get validAufgabenTypen(): string[] {
		if (this.verfuegung.typ == VerfuegungTyp.KORRESPONDENZ) {
			return aufgabenTypenForRegister(this.register, this.isLFPR);
		}

		return aufgabenTypenForRegister(this.register, this.isLFPR).filter(value => value !== AufgabenTyp.ANSCHREIBEN);
	}

	hasNoAufgabeTyp(): boolean {
		return this.formService.form.controls.typ.value == null;
	}
}
